module.exports = __webpack_public_path__ + "static/img/product_05.d970ead.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/product/product_05.jpg
// module id = yaht
// module chunks = 2